import { apiUrl } from '../../context/context';
import { acerillAuthenticatedAxios } from './acerill-axios-instances';

const baseUrl = `${apiUrl}/upload/v1`;

const findDropboxOAuthSettings = () => {
  return acerillAuthenticatedAxios
    .get(baseUrl + '/dropbox/oauth-settings')
    .then(response => response.data);
};

const findDropboxAccounts = () => {
  return acerillAuthenticatedAxios
    .get(baseUrl + '/dropbox/accounts')
    .then(response => response.data);
};

const deleteDropboxAccount = id => {
  return acerillAuthenticatedAxios
    .delete(baseUrl + '/dropbox/accounts/' + encodeURIComponent(id));
};

const getGoogleDriveOauthStep1Url = (accountName, defaultFolderName, supportEmail) =>
  `${baseUrl}/google-drive/oauth/step-1?` +
  `product=custom-forms&name=${encodeURIComponent(accountName)}&` +
  `default_folder_name=${encodeURIComponent(defaultFolderName)}&support_email=${encodeURIComponent(supportEmail)}`;

const findGoogleDriveAccounts = async () => {
  const {data} = await acerillAuthenticatedAxios.get(`${baseUrl}/google-drive/accounts`);
  return data;
};

const findGoogleDriveAccountById = async id => {
  const {data} = await acerillAuthenticatedAxios.get(`${baseUrl}/google-drive/accounts/${id}`);
  return data;
};

const updateGoogleDriveAccount = account => acerillAuthenticatedAxios.patch(
  `${baseUrl}/google-drive/accounts/${account.id}`,
  account
);

const deleteGoogleDriveAccount = id =>
  acerillAuthenticatedAxios.delete(`${baseUrl}/google-drive/accounts/${id}`);

const uploadV1Client = {
  findDropboxOAuthSettings,
  findDropboxAccounts,
  deleteDropboxAccount,
  getGoogleDriveOauthStep1Url,
  findGoogleDriveAccounts,
  findGoogleDriveAccountById,
  updateGoogleDriveAccount,
  deleteGoogleDriveAccount,
};

export default uploadV1Client;
